import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { Observable } from "rxjs";
import { LoggingService } from "../services/logging.service";

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const salesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  try {
    const authService = inject(AuthService);
    
    // First check if component implements canDeactivate
    if (component?.canDeactivate) {
      const componentCanDeactivate = component.canDeactivate();
      
      // Handle Observable, Promise, or boolean return types
      if (componentCanDeactivate instanceof Observable || componentCanDeactivate instanceof Promise) {
        return componentCanDeactivate;
      }
      // If component says no, respect that
      if (!componentCanDeactivate) {
        return false;
      }
    }
    // Then check service-level navigation disable
    if (authService?.disableNavigation$?.value) {
      return false;
    }
    return true;
  } catch (error) {
    const loggingService = inject(LoggingService);
    loggingService.logError("SalesGuard error", error);
    return true;
  }
};
